module.exports = __webpack_public_path__ + "static/img/07.1cdebc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/07.jpg
// module id = xHQq
// module chunks = 0